import PropTypes from 'prop-types';
var StatusPropTypes = PropTypes.oneOf(['complete', 'incomplete', 'error']);
export var RequirementItemPropTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  label: PropTypes.string.isRequired,
  status: StatusPropTypes
};
export var RequirementPropTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  label: PropTypes.string.isRequired,
  requirements: PropTypes.arrayOf(PropTypes.shape(RequirementItemPropTypes).isRequired),
  status: StatusPropTypes
};
export var RequirementsPropTypes = {
  error: PropTypes.bool.isRequired,
  hideRequirements: PropTypes.bool.isRequired,
  isCompact: PropTypes.bool.isRequired,
  requirements: PropTypes.arrayOf(PropTypes.shape(RequirementPropTypes).isRequired).isRequired,
  requirementsErrorTitle: PropTypes.string.isRequired
};